import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { getApiUrl } from "../../utils/baseUrl";
import axios from "axios";
import { toast } from "react-toastify";
import globalErrorHandling, { handleDownloadError, isJsonResponse } from "../../utils/utils";
import ReactTooltip from "react-tooltip";
import Table from "../trademo-datatable/DataTable";
import LoaderImg from "../../assets/images/loader.gif";
import NoSearchDataComponent from "../country-components/no-search-data";
import DataTable from "react-data-table-component";
import moment from "moment";
import LocalStorageService from "../../core/services/local-storage.service";
import { getInternationalNumberSystem } from "../../core/utility/utility";
import { ChevronLeft, ChevronRight, Info } from "react-feather";
import commaFormat from "../../utils/commaFormat";
import trackingEventDictionary from "../../core/dictionary/tracking-event";
import { trademoTrackingEvents } from "../../core/global/trademo-tracking";
import { generateTrackingObject } from "../../core/global/global-country-functions";
import "./viewTrendsReport.scss";
import DownloadModal from "./DownloadModal";
const localStorageService = LocalStorageService.getService();

const intelAPIEndpoints = {
  downloadExcel: getApiUrl("create_excel_analytics_view_all"),
};
const customStyles = {
  rows: {
    style: {
      maxHeight: "48px",
      minHeight: "48px",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderLeft: "1px solid #eaeaea",
      borderBottom: "1px solid #eaeaea !important",
    },
  },
};

const tableCustomStyles = {
  rows: {
    style: {
      maxHeight: "48px",
      minHeight: "48px",
      borderBottom: "none !important",
    },
  },
  headCells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
    },
  },
  cells: {
    style: {
      paddingLeft: "8px",
      paddingRight: "8px",
      borderLeft: "1px solid #eaeaea",
      borderBottom: "1px solid #eaeaea !important",
    },
  },
};

const ViewTrendsReport = ({ handleClose, viewTrendsFinalSearchReqObj, country, tradeDirection, currentKeyViewTrendItem, twoColumnMapping, trendsAPI, trendsDropdownOptions, pathname, currentUserPlan, analyticsCountryID, onCloseModal, report, setCurrentViewedIndex, index, reportsLength, currentViewedIndex }) => {
  const [showTrendsModal, setShowTrendsModal] = useState(false);
  const [loader, setLoader] = useState(true);
  const [defaultTrendsData, setDefaultTrendsData] = useState([]);
  const [defaultTrendsColumns, setDefaultTrendsColumns] = useState([]);
  const [dynamicTrendsData, setDynamicTrendsData] = useState([]);
  const [dynamicTrendsColumns, setDynamicTrendsColumns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortOrder, setSortOrder] = useState("desc");
  const [analysisIndexKey, setAnalysisIndexKey] = useState(null);
  const [analyticsTrends_mustnot_Data, setAnalyticsTrends_mustnot_Data] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [dataCount, setDataCount] = useState(0);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [clearButton, setClearButton] = useState(false);
  const showTwoLevel = report?.is_second_level ?? false;
  const [defaultTwoLevelColumn, setDefaultTwoLevelColumn] = useState(report.secondary_attribute_field);
  const [show, setShow] = useState(false);
  const [downloadFromValue, setDownloadFromValue] = useState(1);
  const [downloadToValue, setDownloadToValue] = useState(100);
  const [showDownloadImpExpModal, setShowDownloadImpExpModal] = useState(false);
  const [existingReqObj, setExistingReqObj] = useState({});
  const [data, setData] = useState([]);
  const [defaultPage, setDefaultPage] = useState(1);
  const [twolevelData, setLevelTwoData] = useState();
  const [viewAllPerPage, setViewAllPerPage] = useState(10);
  const [valueChanged, setValueChanged] = useState(false);
  const [pagination, setPagination] = useState("");
  const [setMaxPaginate, maxPaginate] = useState([]);
  const options = trendsDropdownOptions || [];

  useEffect(() => {
    let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};

    searchRequestObj.must_not = [];
    searchRequestObj.isTrends = true;
    searchRequestObj.order = sortOrder;
    searchRequestObj.trendType = report?.trend_type;
    findAnalysisKeyInList(!!viewTrendsFinalSearchReqObj && !!viewTrendsFinalSearchReqObj.analysis && viewTrendsFinalSearchReqObj.analysis !== "" ? viewTrendsFinalSearchReqObj.analysis : "");
    viewTrends({ ...searchRequestObj, order: "desc" });
    handleOpen();
  }, []);

  useEffect(() => {
    trademoTrackingEvents(getPendoKey(trackingEventDictionary.reportView), generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
  }, []);

  const getPendoKey = (key) => {
    return `${analyticsCountryID.toLowerCase().replace("-", "_")}${report?.report_name?.toLowerCase().replace("top", "").replaceAll(" ", "_")}_${key}`;
  };

  useEffect(() => {
    handleOpen();
  }, [show]);

  const fieldHandler = (row, obj) => {
    if (row?.field4) {
      obj.subFields4 = row.field4;
    }
    if (row?.field3) {
      obj.subFields3 = row.field3;
    }
    if (row?.field2) {
      obj.subFields2 = row.field2;
    }
    if (row?.field1) {
      obj.subFields1 = row.field1;
    }
  };

  const findAnalysisKeyInList = (data) => {
    if (!!data && data !== "") {
      let tempValue = "";
      for (let i = 0; i < options.length; i++) {
        if (data.includes(options[i].value)) {
          tempValue = options.indexOf(options[i]);
          break;
        }
      }
      setAnalysisIndexKey(tempValue);
    }
  };

  const handleSorting = (sortField) => {
    setSortOrder(sortField);
    let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
    searchRequestObj.must_not = [];
    searchRequestObj.isTrends = true;
    searchRequestObj.trendType = report?.trend_type;
    searchRequestObj.order = sortField;
    setSelectedRows([]);
    setTimeout(() => {
      viewTrends(searchRequestObj);
    }, 200);
  };
  useEffect(() => {
    setTimeout(() => {
      handleOpen();
    }, 200);
  }, [defaultTrendsData, data]);

  const viewTrends = (searchRequestObj, comingFrom, type) => {
    if (comingFrom && comingFrom === "pagination") {
      searchRequestObj.must_not = analyticsTrends_mustnot_Data ? analyticsTrends_mustnot_Data : [];
    } else {
      setDataPerPage(10);
      setCurrentPage(1);
    }
    setShowTrendsModal(true);
    setLoader(true);
    if (showTwoLevel) {
      searchRequestObj.isSecondLevelAnalytics = true;
      searchRequestObj.subAnalyticsField = type ? type : defaultTwoLevelColumn;
    } else {
      delete searchRequestObj.isSecondLevelAnalytics;
      delete searchRequestObj.subAnalyticsField;
    }

    setExistingReqObj(searchRequestObj);
    axios.post(trendsAPI, searchRequestObj).then(
      (res) => {
        if (!!res && !!res.data && !!res.data.data) {
          setDataCount(res.data.count);
          if (res.data.count < downloadToValue) {
            setDownloadToValue(res.data.count);
          }
          setDynamicTrendsData(res.data.headers);
          if (!showTwoLevel) {
            if (comingFrom && comingFrom === "pagination") {
              setTimeout(() => {
                setDefaultTrendsData(defaultTrendsData.concat(res.data.data));
                setAnalyticsTrends_mustnot_Data([...analyticsTrends_mustnot_Data, ...res.data.must_not]);
              }, 1000);
            } else {
              setDefaultTrendsData(res.data.data);
              setAnalyticsTrends_mustnot_Data(res.data.must_not);
            }
            setLoader(false);
          } else {
            if (comingFrom && comingFrom === "pagination") {
              let array = [];
              res.data.data.map((item) => {
                if (!!item.sub_data && !!item.sub_data.length) {
                  item.sub_data.map((val, index) => {
                    let obj = { ...val, ...item };
                    obj.key = item.key;
                    obj.subKey = val.key;
                    obj.total = item.total_value;
                    obj.s_no = index + 1;
                    obj.showBorder = index + 1 === item.sub_data.length ? true : false;
                    fieldHandler(val, obj);
                    array.push(obj);
                  });
                } else {
                  let obj = { ...item };
                  obj.key = item.key;
                  obj.subKey = "NA";
                  obj.total = item.total_value;
                  obj.s_no = 1;
                  obj.showBorder = true;
                  array.push(obj);
                }
              });
              setTimeout(() => {
                setLevelTwoData(twolevelData.concat(res.data.data));
                setDefaultTrendsData(defaultTrendsData.concat(array));
                setAnalyticsTrends_mustnot_Data([...analyticsTrends_mustnot_Data, ...res.data.must_not]);
                setLoader(false);
              }, 1000);
            } else {
              let array = [];
              res.data.data.map((item) => {
                if (!!item.sub_data && !!item.sub_data.length) {
                  item.sub_data.map((val, index) => {
                    let obj = { ...val, ...item };
                    obj.key = item.key;
                    obj.subKey = val.key;
                    obj.total = item.total_value;
                    obj.s_no = index + 1;
                    fieldHandler(val, obj);
                    obj.showBorder = index + 1 === item.sub_data.length ? true : false;
                    array.push(obj);
                  });
                } else {
                  let obj = { ...item };
                  obj.key = item.key;
                  obj.subKey = "NA";
                  obj.total = item.total_value;
                  obj.s_no = 1;
                  obj.showBorder = true;
                  array.push(obj);
                }
              });
              setTimeout(() => {
                setLoader(false);
              }, 1000);
              setLevelTwoData(res.data.data);
              setDefaultTrendsData(array);
              setAnalyticsTrends_mustnot_Data(res.data.must_not);
            }
          }
        }
      },
      () => {
        toast.error("Something went wrong. Please try again after sometime!!!");
      }
    );
  };
  const handleClick = (event) => {
    trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalyticsAttribute, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    event.stopPropagation();
    setShow(!show);
  };

  const selectTypeHandler = (type) => {
    setDefaultTwoLevelColumn(() => type);
    setValueChanged(currentKeyViewTrendItem.defaultKey === type ? false : true);
    setTimeout(() => {
      viewTrends(viewTrendsFinalSearchReqObj, "", type);
      setShow(!show);
    }, 100);
  };

  const handleOpen = () => {
    setShowTrendsModal(true);
    setDefaultTrendsColumns([
      {
        omit: showTwoLevel,
        name: "S No.",
        selector: "id",
        sortable: false,
        grow: 0,
        maxWidth: "42px !important",
        minWidth: "42px !important",
      },
      {
        omit: (!!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].key) || (!!data && data.length > 0 && !!data[0].key) ? false : true,
        name: <span>{currentKeyViewTrendItem && currentKeyViewTrendItem.label ? currentKeyViewTrendItem.label.replace("", "") : report?.primary_attribute_label ? report?.primary_attribute_label : "Data"}</span>,
        selector: "key",
        sortable: false,
        grow: 1,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.key && row.key !== "" && row.key.length > 25 ? row.key : ""} data-for="first">
            {!showTwoLevel ? (
              <div>
                {!!row.key && row.key !== "" && typeof row.key === "string" ? <span>{row.key.slice(0, 25).toLowerCase()}</span> : ""}
                {!!row.key && row.key !== "" && row.key.length > 25 ? <span>...</span> : <></>}
                <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="first" />
              </div>
            ) : (
              <div className="twolevelkeyContainer">
                {row.s_no === 1 ? (
                  <div className="text-left">
                    {!!row.key && row.key !== "" && typeof row.key === "string" ? <span>{row.key.slice(0, 25).toLowerCase()}</span> : ""}
                    {!!row.key && row.key !== "" && row.key.length > 25 ? <span>...</span> : <></>}
                    <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="first" />
                    <div className="text-left total_count_twolevl">{options[analysisIndexKey] ? options[analysisIndexKey].table_header : options[0].table_header}</div>
                    <div className="total_count_twolevl">( {showTwoLevel && !!row.total ? commaFormat(row.total) : "NA"} ) </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            )}
          </div>
        ),
      },

      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field1 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerOne ? currentKeyViewTrendItem.headerOne : "Data"}</div>,
        selector: "field1",
        sortable: false,
        grow: 2,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.field1 && row.field1 !== "" && row.field1.length > 18 ? row.field1 : ""} data-for="field01">
            {!!row.field1 && row.field1 !== "" ? <span>{row.field1.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field1 && row.field1 !== "" && row.field1.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field01" />
          </div>
        ),
      },
      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field2 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerTwo ? currentKeyViewTrendItem.headerTwo : "Data"}</div>,
        selector: "field2",
        sortable: false,
        grow: 2,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.field2 && row.field2 !== "" && row.field2.length > 18 ? row.field2 : ""} data-for="field02">
            {!!row.field2 && row.field2 !== "" ? <span>{row.field2.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field2 && row.field2 !== "" && row.field2.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field02" />
          </div>
        ),
      },
      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field3 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerThree ? currentKeyViewTrendItem.headerThree : "Data"}</div>,
        selector: "field3",
        sortable: false,
        grow: 2,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.field3 && row.field3 !== "" && row.field3.length > 18 ? row.field3 : ""} data-for="field03">
            {!!row.field3 && row.field3 !== "" ? <span>{row.field3.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field3 && row.field3 !== "" && row.field3.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field03" />
          </div>
        ),
      },
      {
        omit: !!defaultTrendsData && defaultTrendsData.length > 0 && !!defaultTrendsData[0].field4 && !showTwoLevel ? false : true,
        name: <div className="d-flex align-items-center">{currentKeyViewTrendItem && currentKeyViewTrendItem.headerFour ? currentKeyViewTrendItem.headerFour : "Data"}</div>,
        selector: "field4",
        sortable: false,
        grow: 2,
        format: (row) => (
          <div className="text-capitalize" data-tip={!!row.field4 && row.field4 !== "" && row.field4.length > 18 ? row.field4 : ""} data-for="field04">
            {!!row.field4 && row.field4 !== "" ? <span>{row.field4.slice(0, 18).toLowerCase()}</span> : ""}
            {!!row.field4 && row.field4 !== "" && row.field4.length > 18 ? <span>...</span> : <></>}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="field04" />
          </div>
        ),
      },
      {
        omit: !(!!data && data.length > 0 && !!data[0].field1 && showTwoLevel && (!!data[0].field1 || !!data[0].field2 || !!data[0].field3 || !!data[0].field4) && !!currentKeyViewTrendItem.grpType),
        name: <div>{currentKeyViewTrendItem.label ? currentKeyViewTrendItem.label.replace("", "") : ""}</div>,
        selector: "field1",
        sortable: false,
        grow: 3,
        format: (row) => (
          <div className="text-capitalize">
            {row.s_no === 1 ? (
              <div className="position-relative">
                <div data-for="routetooltip" data-tip={(!!row.field1 && typeof row.field1 === "string" ? row.field1.toUpperCase() : "") + (!!row.field2 && typeof row.field2 === "string" ? " → " + row.field2.toUpperCase() : "") + (!!row.field3 && typeof row.field3 === "string" ? " → " + row.field3.toUpperCase() : "") + (!!row.field4 && typeof row.field4 === "string" ? " → " + row.field4.toUpperCase() : "")} className="d-flex">
                  {!!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string" && !!row.field4 && typeof row.field4 === "string"
                    ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).length > 110
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase().slice(0, 110) + "..."
                      : (row.field1 + " → " + row.field2 + " → " + row.field3 + " → " + row.field4).toUpperCase()
                    : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string" && !!row.field3 && typeof row.field3 === "string"
                      ? (row.field1 + " → " + row.field2 + " → " + row.field3).length > 110
                        ? (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase().slice(0, 110) + "..."
                        : (row.field1 + " → " + row.field2 + " → " + row.field3).toUpperCase()
                      : !!row && !!row.field1 && typeof row.field1 === "string" && !!row.field2 && typeof row.field2 === "string"
                        ? (row.field1 + " → " + row.field2).length > 110
                          ? (row.field1 + " → " + row.field2).toUpperCase().slice(0, 110) + "..."
                          : (row.field1 + " → " + row.field2).toUpperCase()
                        : !!row && !!row.field1 && typeof row.field1 === "string"
                          ? row.field1.toUpperCase()
                          : ""}
                </div>
                <div className="text-left total_count_twolevl">{options[analysisIndexKey] ? "Total " + options[analysisIndexKey].value : options[0].value}</div>
                <div className="total_count_twolevl">( {showTwoLevel && !!row.total ? row.total : ""} ) </div>
              </div>
            ) : (
              ""
            )}
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="routetooltip" />
          </div>
        ),
      },
      {
        omit: !showTwoLevel,
        selector: "subKey",
        name: (
          <div className="position-relative">
            <div className="cursor-pointer" onClick={(e) => handleClick(e)}>
              <span>{twoColumnMapping && defaultTwoLevelColumn ? twoColumnMapping[defaultTwoLevelColumn] : ""}</span>
            </div>
            {show ? (
              <div className="position-absolute twoLevelPopOver">
                {Object.keys(twoColumnMapping).map((item) =>
                  item !== currentKeyViewTrendItem.key ? (
                    <div
                      key={item}
                      onClick={() => {
                        setDefaultTwoLevelColumn(item);
                        selectTypeHandler(item);
                      }}
                      className={`px-2 twolevel_option_icons cursor-pointer ${item === defaultTwoLevelColumn ? "py-2 twolevel_option_icons-selected" : "py-2"}`}>
                      <p className="d-flex justify-content-between m-0 ">
                        <span className="cursor-pointer">{item !== currentKeyViewTrendItem.key ? twoColumnMapping[item] : ""}</span>
                        <span>{item === defaultTwoLevelColumn ? <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1674129102/intel/icons/check_circle_purple_l0h7eg.svg" /> : ""}</span>
                      </p>
                    </div>
                  ) : (
                    ""
                  )
                )}
              </div>
            ) : (
              ""
            )}
          </div>
        ),
        sortable: false,
        grow: 3,
        format: (row) => (
          <div className="text-capitalize d-flex align-items-center">
            <p data-tip={row.subKey} data-for="sub-key" className="m-0 d-flex align-items-center">
              {row.subKey ? row.subKey.slice(0, 60) : ""}
              {!!row.subKey && row.subKey.length > 60 ? "..." : ""}
            </p>
            {valueChanged ? (
              <div className="position-relative">
                <div data-for="sub-key1" data-tip={(!!row.subFields1 && typeof row.subFields1 === "string" ? row.subFields1.toUpperCase() : "") + (!!row.subFields2 && typeof row.subFields2 === "string" ? " → " + row.subFields2.toUpperCase() : "") + (!!row.subFields3 && typeof row.subFields3 === "string" ? " → " + row.subFields3.toUpperCase() : "") + (!!row.subFields4 && typeof row.subFields4 === "string" ? " → " + row.subFields4.toUpperCase() : "")} className="d-flex">
                  {!!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string" && !!row.subFields3 && typeof row.subFields3 === "string" && !!row.subFields4 && typeof row.subFields4 === "string"
                    ? (row.subFields1.length > 60 ? row.subFields1.slice(0, 60) + "..." : row.subFields1 + " → " + row.subFields2.length > 60 ? row.subFields2.slice(0, 60) + "..." : row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).length > 110
                      ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).toUpperCase().slice(0, 110) + "..."
                      : (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3 + " → " + row.subFields4).toUpperCase()
                    : !!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string" && !!row.subFields3 && typeof row.subFields3 === "string"
                      ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).length > 110
                        ? (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).toUpperCase().slice(0, 110) + "..."
                        : (row.subFields1 + " → " + row.subFields2 + " → " + row.subFields3).toUpperCase()
                      : !!row && !!row.subFields1 && typeof row.subFields1 === "string" && !!row.subFields2 && typeof row.subFields2 === "string"
                        ? (row.subFields1 + " → " + row.subFields2).length > 110
                          ? (row.subFields1 + " → " + row.subFields2).toUpperCase().slice(0, 110) + "..."
                          : (row.subFields1 + " → " + row.subFields2).toUpperCase()
                        : !!row && !!row.subFields1 && typeof row.subFields1 === "string"
                          ? row.subFields1.toUpperCase()
                          : ""}
                </div>
              </div>
            ) : (
              ""
            )}

            <ReactTooltip
              getContent={[
                (dataTip) => {
                  return (
                    <span>
                      {dataTip ? <p className="m-0">{dataTip.slice(0, 110)}</p> : ""}
                      {!!dataTip && dataTip.length > 110 ? <p className={`${!!dataTip && dataTip.length > 220 ? "m-0" : ""}`}>{dataTip.slice(110, 220)}</p> : ""}
                      {!!dataTip && dataTip.length > 220 ? <p className="m-0">{dataTip.slice(220, dataTip.length)}</p> : ""}
                    </span>
                  );
                },
                100,
              ]}
              className="trademo-tooltip"
              backgroundColor="#8C8C8C"
              textColor="#FFFFFF"
              place="top"
              id="sub-key"
            />
            <ReactTooltip className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="sub-key1" />
          </div>
        ),
      },
      {
        name: <span>{analysisIndexKey ? options[analysisIndexKey].table_header : options[0].table_header}</span>,
        selector: "data_value",
        sortable: showTwoLevel ? false : true,
        maxWidth: "108px !important",
        minWidth: "108px !important",
        grow: 2,
        format: (row) => (
          <div>
            {row.data_value !== null || row.data_value === 0 ? (typeof row.data_value === "number" ? getInternationalNumberSystem(row.data_value) : row.data_value) : ""}
            {showTwoLevel ? <span className="d-block two_level_per_change text-left">{row.data_value_percentage ? "(" + row.data_value_percentage + "%)" : "NA"}</span> : ""}
          </div>
        ),
      },
      {
        name: (
          <div className="d-flex align-items-center">
            % Overall Change
            <div>
              <Info className="mx-1" place="middle" color="#8C8C8C" size={13} data-tip={"% Overall Change is the relative percentage change between the Trade Volume for the earliest and latest time period"} data-for="xyz" />
              <ReactTooltip className="overall-change__tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" id="xyz" />
            </div>
          </div>
        ),
        selector: "overall_percent_change",
        sortable: false,
        maxWidth: "121px !important",
        right: true,
        grow: 1,
        format: (row) => <div>{row.overall_percent_change >= 0 ? <span className="positive">↑{row.overall_percent_change}%</span> : <span className="negative">↓{Math.abs(row.overall_percent_change)}%</span>}</div>,
      },
    ]);
    let arr = [];
    dynamicTrendsData?.map((item, index) => {
      const column = {
        name:
          index === 0 ? (
            <div className="tw-w-full tw-h-full trends-tooltip-cell" data-tip="Trends are updated to the latest shipment date" data-for={`header-tooltip-${index}`} style={{ whiteSpace: "nowrap" }}>
              <div>
                {item}
                <svg xmlns="http://www.w3.org/2000/svg" height="8px" viewBox="0 -960 960 960" width="8px" fill="#101828" style={{ marginTop: "-10px" }}>
                  <path d="M454-164v-252.85L274.92-238.16l-36.76-36.76L416.85-454H164v-52h252.85L238.16-685.08l36.76-36.38L454-542.77V-796h52v253.23l179.08-178.69 36.38 36.38L542.77-506H796v52H542.77l178.69 179.08-36.38 36.76L506-416.85V-164h-52Z" />
                </svg>
              </div>
              <ReactTooltip id={`header-tooltip-${index}`} className="trademo-tooltip" backgroundColor="#8C8C8C" textColor="#FFFFFF" place="top" />
            </div>
          ) : (
            item
          ),
        selector: "id",
        sortable: false,
        right: true,
        grow: 0,
        separator: true,
        format: (row) => (
          <div className="text-right">
            <span className="">{row[item] !== undefined && row[item] !== null && row[item].value !== undefined && row[item].value !== null ? getInternationalNumberSystem(row[item].value) : ""}</span>
            <br />
            {index !== dynamicTrendsData.length - 1 ? row[item] && (row[item].percent_change || row[item].percent_change === 0) && row[item].percent_change >= 0 ? <span className="growth-change positive text-right">↑{row[item].percent_change.toFixed(2)}%</span> : row[item] && (row[item].percent_change || row[item].percent_change === 0) ? <span className="growth-change negative text-right">↓{Math.abs(row[item].percent_change).toFixed(2)}%</span> : "" : ""}
          </div>
        ),
      };
      arr.push(column);
    });
    setDynamicTrendsColumns(arr);
  };
  const trendsModalClose = (event) => {
    if (event) {
      event.preventDefault();
    }
    onCloseModal();
    handleClose(true);
    setShowTrendsModal(false);
    setAnalyticsTrends_mustnot_Data([]);
  };

  const selectedRowCheck = (row) => {
    return selectedRows.includes(row) === true ? true : false;
  };
  const mapSelectedValue = (data) => {
    setTimeout(() => {
      setSelectedRows([...data]);
    }, 100);
  };
  const callingDownloadAPI = (data, isRangeViewAll) => {
    if (data) {
      trademoTrackingEvents(getPendoKey(trackingEventDictionary.reportDownloadConfirm), generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    }
    const downloadPayload = {};
    if (!isRangeViewAll) {
      downloadPayload.data_download = [...data];
      downloadPayload._payload = existingReqObj;
      downloadPayload._payload.email = false;
    } else {
      downloadPayload._payload = existingReqObj;
      downloadPayload._payload.from = downloadFromValue - 1;
      downloadPayload._payload.size = Math.abs(downloadToValue - downloadFromValue) + 1;
      downloadPayload._payload.email = true;
      downloadPayload._payload.must_not = [];
      downloadPayload._payload.analysis = report?.analysis_on;
      downloadPayload._payload.analyticsField = report?.primary_attribute_field;
    }
    if (showTwoLevel) {
      downloadPayload.subAnalyticsField = report?.secondary_attribute_field;
    }

    if (+downloadToValue < +downloadFromValue) {
      toast.error("TO value must be greater than FROM value");
      return false;
    }

    downloadPayload.isSecondLevelAnalytics = showTwoLevel ? true : false;
    downloadPayload.isRangeViewAll = isRangeViewAll === true ? isRangeViewAll : false;

    downloadPayload.file_name = "Analytics_TrendsViewAll_" + moment.utc().format("DD-MM-YYYY") + "_" + new Date().getTime() + ".xlsx";
    downloadPayload.analysis = report?.analysis_on;
    downloadPayload.tradeDirection = !!tradeDirection && tradeDirection !== "" ? tradeDirection : "";
    downloadPayload.country = !!country && country !== "" ? country : "";
    downloadPayload.headers = dynamicTrendsData ? dynamicTrendsData : [];
    downloadPayload.analyticsField = report?.primary_attribute_field;
    if (isRangeViewAll) {
      axios.post(intelAPIEndpoints.downloadExcel, downloadPayload).then(
        (res) => {
          if (!!res && !!res.data && !!res.data.status && res.data.status === "success") {
            toast.success(res.data.message);
            setShowDownloadImpExpModal(false);
          } else {
            globalErrorHandling(res);
          }
        },
        () => {
          toast.error("Something went wrong. Please try again later !!!");
        }
      );
    } else {
      downloadPayload._payload.email = false;
      const request = new XMLHttpRequest();
      request.open("POST", intelAPIEndpoints.downloadExcel, true);
      request.setRequestHeader("Content-Type", "application/x-www-form-urlencoded; charset=UTF-8");
      request.responseType = "blob";
      request.setRequestHeader("sessionId", LocalStorageService.getSessionID());
      request.setRequestHeader("ssoToken", localStorageService.getAccessToken());
      request.onload = function () {
        if (request.status === 200 && !isJsonResponse(request)) {
          const contentTypeHeader = request.getResponseHeader("Content-Type");
          const file = new Blob([this.response], { type: contentTypeHeader });
          const url = window.URL.createObjectURL(file);
          const a = document.createElement("a");
          document.body.appendChild(a);
          a.href = url;
          a.download = downloadPayload.file_name;
          a.click();
        } else {
          handleDownloadError(request);
        }
      };
      request.send(JSON.stringify(downloadPayload), this);
      setShowDownloadImpExpModal(false);
    }
  };

  const handleSearchPerRowsChange = (e) => {
    setDataPerPage(e);
  };
  const handlePageChange = (e) => {
    setCurrentPage(e);
    if (defaultTrendsData.length <= e * dataPerPage) {
      if (e * dataPerPage < dataCount) {
        // equal to removed to handle equal data issue
        let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
        viewTrends(searchRequestObj, "pagination");
      }
    }
  };

  const downloadRangeFilter = () => {
    trademoTrackingEvents(getPendoKey(trackingEventDictionary.reportDownloadEmailConfirm), generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
    callingDownloadAPI("", true);
  };

  useEffect(() => {
    if (!!twolevelData && !!twolevelData.length) {
      if (!twolevelData[defaultPage * (viewAllPerPage / 5)] && defaultPage * (viewAllPerPage / 5) < dataCount) {
        let searchRequestObj = viewTrendsFinalSearchReqObj ? viewTrendsFinalSearchReqObj : {};
        viewTrends(searchRequestObj, "pagination");
      } else {
        let toPage = (defaultPage * viewAllPerPage) / 5 - 1;
        let fromPage = toPage - viewAllPerPage / 5 + 1;
        let array = [];
        for (let i = fromPage; i <= toPage; i++) {
          if (!!twolevelData[i] && !!twolevelData[i].sub_data && !!twolevelData[i].sub_data.length) {
            twolevelData[i].sub_data.map((val, index) => {
              let obj = { ...val, ...twolevelData[i] };
              obj.key = twolevelData[i].key;
              obj.subKey = val.key;
              obj.total = twolevelData[i].total_value;
              obj.s_no = index + 1;
              fieldHandler(val, obj);
              obj.showBorder = index + 1 === twolevelData[i].sub_data.length ? true : false;
              array.push(obj);
            });
          } else if (twolevelData[i]) {
            let obj = { ...twolevelData[i] };
            obj.key = twolevelData[i].key;
            obj.subKey = "NA";
            obj.total = twolevelData[i].total_value;
            obj.s_no = 1;
            obj.showBorder = true;
            array.push(obj);
          }
        }
        setData([]);
        setTimeout(() => {
          setData([...array]);
        }, 100);
      }
    }
  }, [defaultPage, viewAllPerPage, pagination, twolevelData]);

  useEffect(() => {
    if (data.length) {
      let val = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination select option");
      val = document.querySelectorAll(".lvl-two-table-container-route .rdt_Pagination select option").length ? document.querySelectorAll(".lvl-two-table-container-route .rdt_Pagination select option") : val;
      if (!!val && !!val.length) {
        val[0].textContent = 2;
        val[1].textContent = 5;
      }
      let range = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination span");
      range = document.querySelectorAll(".lvl-two-table-container-route .rdt_Pagination span").length ? document.querySelectorAll(".lvl-two-table-container-route .rdt_Pagination span") : range;
      if (!!range && !!range.length) {
        let toPage = (defaultPage * viewAllPerPage) / 5 - 1;
        let fromPage = toPage - viewAllPerPage / 5 + 1;
        range[1].textContent = fromPage + 1 + " - " + (toPage + 1) + " of " + dataCount;
      }
      let prevPage = document.querySelectorAll(".lvl-two-table-container #pagination-previous-page");
      prevPage = document.querySelectorAll(".lvl-two-table-container-route #pagination-previous-page").length ? document.querySelectorAll(".lvl-two-table-container-route #pagination-previous-page") : prevPage;
      if (!!prevPage && !!prevPage.length && defaultPage > 1) {
        prevPage[0].removeAttribute("disabled");
      }
      let nextPage = document.querySelectorAll(".lvl-two-table-container #pagination-next-page");
      nextPage = document.querySelectorAll(".lvl-two-table-container-route #pagination-next-page").length ? document.querySelectorAll(".lvl-two-table-container-route #pagination-next-page") : nextPage;
      if (!!nextPage && !!nextPage.length && defaultPage * (viewAllPerPage / 5) >= dataCount) {
        nextPage[0].setAttribute("disabled", true);
      }
      let rows = document.querySelectorAll(".lvl-two-table-container .rdt_TableRow");
      rows = document.querySelectorAll(".lvl-two-table-container-route .rdt_TableRow").length ? document.querySelectorAll(".lvl-two-table-container-route .rdt_TableRow") : rows;
      if (!!rows && !!rows.length) {
        data.forEach((item, index) => {
          if (!item.showBorder && !!rows[index]) {
            let firstChild = rows[index].firstChild;
            firstChild.style.setProperty("border-bottom", "none", "important");
          }
        });
      }
      let pagination = document.querySelectorAll(".lvl-two-table-container .rdt_Pagination");
      pagination = document.querySelectorAll(".lvl-two-table-container-route .rdt_Pagination").length ? document.querySelectorAll(".lvl-two-table-container-route .rdt_Pagination") : pagination;
      if (!!pagination && !!pagination.length && !!data && data.length < 8) {
        pagination[0].style.marginTop = -(48 * (10 - data.length)) + 30 + "px";
      }
    }
  });

  const goToNext = (e) => {
    e.preventDefault();
    // change 6 by reports length
    setCurrentViewedIndex((prevIndex) => (prevIndex !== null && prevIndex < reportsLength - 1 ? prevIndex + 1 : null));
    trademoTrackingEvents(trackingEventDictionary.reportPopupNext, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
  };
  const goToPrevious = () => {
    setCurrentViewedIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : null));
    trademoTrackingEvents(trackingEventDictionary.reportPopupPrevious, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
  };
  return (
    <div>
      <Modal show={showTrendsModal} onHide={(e) => trendsModalClose(e)} size="xl" onClick={() => setShow(false)} keyboard={false} centered className="trademo-modal trademo-trends-modal">
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between w-100 header">
            <div className="left">
              <h4>
                {index + 1} of {reportsLength} reports
              </h4>
              <div className="left-btns">
                <button className="prev-btn" onClick={goToPrevious} disabled={currentViewedIndex === 0}>
                  {" "}
                  <ChevronLeft size={20} /> <span>Previous Report</span>
                </button>
                <button className="next-btn" onClick={goToNext} disabled={currentViewedIndex === reportsLength - 1}>
                  <span>Next Report</span> <ChevronRight size={20} />
                </button>
              </div>
            </div>
            <div className="right">
              <button
                onClick={() => {
                  setShowDownloadImpExpModal(true);
                  setDownloadToValue(dataCount < 100 ? dataCount : 100);
                  setDownloadFromValue(1);
                  trademoTrackingEvents(getPendoKey(trackingEventDictionary.reportDownloadEmail), generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                }}
                className="two_level_label donwload-btn-header">
                <img src="https://res.cloudinary.com/drzta9shk/image/upload/v1707282581/intel/icons/agikmdw7iyfbtw3gbtv5.svg" alt="Email Icon" />
                Email Report
              </button>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12 d-flex pb-3">
              <div className="col-md-7 my-auto pl-0 report-heading">
                <h4>{report?.report_name}</h4>
                {selectedRows && selectedRows.length > 0 ? (
                  <div className="d-flex justify-content-between">
                    <div className={`selected-state-row d-flex align-items-center selected-top-box px-1 ${selectedRows.length > 0 ? null : "d-none"}`}>
                      <span className="mx-1">
                        {selectedRows.length > 0 ? (
                          <span className="selected-search-count d-flex align-items-center">
                            <span className={`row-select-count mr-1 ${selectedRows.length > 9 ? "padding" : "extra-padding"}`}>{selectedRows.length}</span>
                            <span>{selectedRows.length === 1 ? "row selected" : "rows selected"}</span>
                          </span>
                        ) : (
                          <></>
                        )}
                      </span>
                      <span className="vr mx-1"></span>
                      <span className="mx-1 d-flex cursor-pointer align-items-center" onClick={() => callingDownloadAPI(selectedRows)}>
                        <img className="pr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875670/intel/Importer-Exporter_Tab/leftbar_icon_download_fqdhxy.svg" alt="Download Icon" />
                        <span>Download</span>
                      </span>
                      <span className="vr mx-1"></span>
                      <span className="mx-1 d-flex cursor-pointer align-items-center" onClick={() => setClearButton(!clearButton)}>
                        <img className="pr-1" src="https://res.cloudinary.com/drzta9shk/image/upload/v1657875752/intel/Importer-Exporter_Tab/leftbar_icon_close_jl6z6l.svg" alt="Clear Icon" />
                        <span>Clear</span>
                      </span>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
            <div className="card w-100 trademo-datatable-card">
              {loader && loader !== "" ? (
                <>
                  <div className="container py-5 my-5 loading-container">
                    <div className="text-center pt-3">
                      <img src={LoaderImg} alt="description of gif" />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="d-flex trends-table">
                    <div className={!!defaultTrendsData && defaultTrendsData.length > 0 && ((!!defaultTrendsData[0].field3 && defaultTrendsData[0].field3 !== "") || (!!defaultTrendsData[0].field4 && defaultTrendsData[0].field4 !== "")) ? "col-8 pr-0" : showTwoLevel ? "col-7 pr-0" : "col-5 pr-0"}>
                      {!showTwoLevel && !!defaultTrendsData.length && !!defaultTrendsColumns.length ? (
                        <div className="react-two-level-trends-datatable">
                          <Table
                            title="Data1"
                            columns={defaultTrendsColumns}
                            paginationTotalRows={dataCount}
                            data={!!defaultTrendsData && defaultTrendsData !== "" ? defaultTrendsData : []}
                            pagination
                            persistTableHead
                            onSort={(e, sortField) => handleSorting(sortField)}
                            defaultSortAsc={sortOrder === "desc" ? false : true}
                            noDataComponent={<NoSearchDataComponent content="No Shipments Found. Please try another search" />}
                            selectableRows={!!country && country !== "" ? true : false}
                            defaultSortField="data_value"
                            selectableRowSelected={selectedRowCheck}
                            onSelectedRowsChange={(selectedRows) => mapSelectedValue(selectedRows)}
                            paginationRowsPerPageOptions={[10, 20, 30]}
                            paginationPerPage={dataPerPage}
                            selectedData={selectedRows}
                            onChangePage={(e) => handlePageChange(e ? e : 1)}
                            onChangeRowsPerPage={(e) => handleSearchPerRowsChange(e)}
                            paginationDefaultPage={currentPage}
                            clearSelectedRows={clearButton}
                            paginationIconPrevious={
                              <>
                                <ChevronLeft />
                              </>
                            }
                            paginationIconNext={
                              <>
                                <ChevronRight />
                              </>
                            }
                          />
                        </div>
                      ) : (
                        <div className={`twolevel ${!currentKeyViewTrendItem.grpType ? "lvl-two-table-container" : "lvl-two-table-container-route"}`}>
                          {!!data.length && !!dynamicTrendsColumns.length ? (
                            <DataTable
                              title="Companies"
                              columns={defaultTrendsColumns}
                              paginationTotalRows={dataCount}
                              className="trademo-datatable trademo-custom-table2"
                              data={!!data && data !== "" ? data : []}
                              customStyles={tableCustomStyles}
                              pagination
                              persistTableHead
                              highlightOnHover
                              paginationIconFirstPage={<></>}
                              paginationIconLastPage={<></>}
                              onSort={(e, sortField) => handleSorting(sortField)}
                              defaultSortAsc={sortOrder === "desc" ? false : true}
                              paginationRowsPerPageOptions={[10, 25]}
                              paginationPerPage={viewAllPerPage}
                              onChangeRowsPerPage={(data) => {
                                setViewAllPerPage(data);
                                setDefaultPage(1);
                                trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalyticsPaginationResultPerPage, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                              }}
                              paginationDefaultPage={defaultPage}
                              paginationIconPrevious={
                                <>
                                  <ChevronLeft
                                    color={defaultPage > 1 ? "rgba(0,0,0,0.54)" : "#D1D1D1"}
                                    onClick={() => {
                                      if (defaultPage > 1) {
                                        trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalyticsPaginationBackward, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                                        setDefaultPage(defaultPage - 1);
                                        setPagination("prev");
                                      }
                                    }}
                                  />
                                </>
                              }
                              paginationIconNext={
                                <>
                                  <ChevronRight
                                    onClick={() => {
                                      if (defaultPage * (viewAllPerPage / 5) >= dataCount) {
                                        return;
                                      }
                                      trademoTrackingEvents(trackingEventDictionary.analyticsTabDashletTrends2ndLevelAnalyticsPaginationForward, generateTrackingObject(analyticsCountryID, pathname, currentUserPlan));
                                      setDefaultPage(defaultPage + 1);
                                      if (defaultPage >= maxPaginate) {
                                        setMaxPaginate(maxPaginate + 1);
                                      }
                                      setPagination("next");
                                    }}
                                  />
                                </>
                              }
                              noDataComponent={<NoSearchDataComponent content="No Shipments Found. Please try another search" />}
                            />
                          ) : (
                            ""
                          )}
                        </div>
                      )}
                    </div>
                    <div className={!!defaultTrendsData && defaultTrendsData.length > 0 && ((!!defaultTrendsData[0].field3 && defaultTrendsData[0].field3 !== "") || (!!defaultTrendsData[0].field4 && defaultTrendsData[0].field4 !== "")) ? "col-4 pl-0 react-two-level-trends-datatable-right" : showTwoLevel ? "col-5 pl-0 react-two-level-trends-datatable-right" : "col-7 pl-0 react-two-level-trends-datatable-right"}>
                      {!showTwoLevel ? (
                        <div>
                          <DataTable title="Data2" className="trademo-datatable trademo-custom-table2" columns={dynamicTrendsColumns} data={!!defaultTrendsData && defaultTrendsData !== "" ? defaultTrendsData.slice((currentPage - 1) * dataPerPage, currentPage * dataPerPage) : []} customStyles={customStyles} persistTableHead highlightOnHover noDataComponent={<NoSearchDataComponent content="No Shipments Found. Please try another search" />} />
                        </div>
                      ) : (
                        <div className="leveltwo-analytics-table ">{!!data.length && !!dynamicTrendsColumns.length ? <DataTable title="Data2" className="trademo-datatable trademo-custom-table2" columns={dynamicTrendsColumns} data={!!data && data !== "" ? data : []} customStyles={customStyles} pagination persistTableHead highlightOnHover noDataComponent={<NoSearchDataComponent content="No Shipments Found. Please try another search" />} paginationRowsPerPageOptions={[10, 25]} paginationPerPage={viewAllPerPage} paginationDefaultPage={defaultPage} /> : ""}</div>
                      )}
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </Modal.Body>
        <DownloadModal showModal={showDownloadImpExpModal} setShowModal={setShowDownloadImpExpModal} downloadFromValue={downloadFromValue} setDownloadFromValue={setDownloadFromValue} downloadToValue={downloadToValue} setDownloadToValue={setDownloadToValue} dataCount={dataCount} downloadRangeFilter={downloadRangeFilter} />
      </Modal>
    </div>
  );
};

export default React.memo(ViewTrendsReport);
